"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var SadGift = function SadGift(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("path", {
    id: "a",
    d: "M0 0h104.442v40.379H0z"
  })), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "123",
    cy: "178.142",
    fill: "#000",
    fillOpacity: ".05",
    fillRule: "nonzero",
    rx: "123",
    ry: "4.858"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#4A90E2",
    fillRule: "nonzero",
    d: "M30.534 66.506h183.96v102.636a9 9 0 0 1-9 9H39.535a9 9 0 0 1-9-9V66.506z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#225DA3",
    fillRule: "nonzero",
    d: "M50.71 66.506v102.636a9 9 0 0 0 9 9H39.535a9 9 0 0 1-9-9V66.506h20.177z"
  }), /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(81.568)"
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/_react.default.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#92BCED",
    d: "M82.917 33.439H60.748l8.665-14.041S74.667 9.329 82.917 9.329c6.644 0 12.03 5.397 12.03 12.055 0 6.658-5.386 12.055-12.03 12.055zm-61.392 0c-6.644 0-12.03-5.397-12.03-12.055 0-6.658 5.386-12.055 12.03-12.055 8.251 0 13.504 10.069 13.504 10.069l8.665 14.04H21.525zM83.241 0C71.53 0 69.966 2.401 52.359 29.19h-.276C34.476 2.4 32.912 0 21.203 0 9.492 0 0 9.512 0 21.245c0 8.42 4.889 15.696 11.977 19.134h80.489c7.087-3.438 11.976-10.714 11.976-19.134C104.442 9.512 94.95 0 83.241 0z",
    mask: "url(#b)"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#4A90E2",
    fillRule: "nonzero",
    d: "M21.04 40.379h202.95v18.315a9 9 0 0 1-9 9H30.04a9 9 0 0 1-9-9V40.379z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#225DA3",
    fillRule: "nonzero",
    d: "M53.084 40.379v18.315a9 9 0 0 0 9 9H30.04a9 9 0 0 1-9-9V40.379h32.045z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#FFF",
    fillOpacity: ".4",
    fillRule: "nonzero",
    d: "M115.987 40.379h37.979v137.763h-37.98z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M30.534 67.694h183.961v5.938H30.534z",
    opacity: ".253"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(85.129 91.446)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#FFF",
    d: "M3.53 22.565C1.334 20.17 0 17.035 0 13.6 0 6.089 6.376 0 14.242 0c7.866 0 14.242 6.09 14.242 13.6 0 3.434-1.332 6.571-3.53 8.965-2.611-2.843-6.442-4.637-10.712-4.637s-8.1 1.794-10.711 4.637z"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "6.528",
    cy: "14.845",
    fill: "#717171",
    opacity: ".5",
    rx: "1.78",
    ry: "1.781"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "11.868",
    cy: "8.313",
    fill: "#717171",
    rx: "3.561",
    ry: "3.563"
  })), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: "4",
    d: "M108.272 135.114c8.902-5.204 17.803-7.806 26.704-7.806 8.902 0 17.803 2.602 26.704 7.806"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(156.34 91.446)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#FFF",
    d: "M3.53 22.565C1.334 20.17 0 17.035 0 13.6 0 6.089 6.376 0 14.242 0c7.866 0 14.242 6.09 14.242 13.6 0 3.434-1.332 6.571-3.53 8.965-2.611-2.843-6.442-4.637-10.712-4.637s-8.1 1.794-10.711 4.637z"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "6.528",
    cy: "14.845",
    fill: "#717171",
    opacity: ".5",
    rx: "1.78",
    ry: "1.781"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "11.868",
    cy: "8.313",
    fill: "#717171",
    rx: "3.561",
    ry: "3.563"
  }))));
};

SadGift.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "246",
  height: "183",
  viewBox: "0 0 246 183"
};
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    imageWrapper: {
      textAlign: 'center',
      padding: spacing(4)
    },
    messageWrapper: {
      paddingLeft: spacing(2),
      paddingRight: spacing(2),
      fontSize: 24
    },
    message: {
      color: palette.primary.main,
      textAlign: 'center'
    },
    buttonWrapper: {
      padding: spacing(4)
    },
    sendButton: {
      color: palette.primary.main
    }
  };
});

var EmptyGiftsHistory = function EmptyGiftsHistory(_ref2) {
  var userName = _ref2.userName,
      handleGiftCreate = _ref2.handleGiftCreate;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    className: classes.imageWrapper
  }, /*#__PURE__*/_react.default.createElement(SadGift, null)), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    className: classes.messageWrapper
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    className: classes.message
  }, "".concat(userName, " hasn\u2019t received any gifts yet!"))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    className: classes.buttonWrapper
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: classes.sendButton,
    fullWidth: true,
    variant: "contained",
    color: "secondary",
    onClick: handleGiftCreate
  }, "Send them their first gift!")));
};

EmptyGiftsHistory.propTypes = {
  userName: _propTypes.default.string.isRequired,
  handleGiftCreate: _propTypes.default.func.isRequired
};
var _default = EmptyGiftsHistory;
exports.default = _default;